// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.client-list[data-v-58ad6190] {\n    color: #8C979A;\n}\n.client-list .client-list-item[data-v-58ad6190] {\n    margin-bottom: 15px;\n}\n.client-list-item *[data-v-58ad6190]:hover {\n    cursor: pointer;\n    color: teal;\n}\n", ""]);
// Exports
module.exports = exports;
